import { Global } from '@utils/common';
import { CustomColumnHeader, CustomColumnType, getAdderColumnType } from 'types';
import { DEFAULT_MAX_ADDER_COLUMN_COUNT } from '@utils/line-items/columnHelpers';

const isDescriptiveColumn = (header: CustomColumnHeader): boolean => {
  if (!header || header._destroy) return false;
  const descriptive = Global.lots.custom_column_headers.column_types.descriptive as CustomColumnType;

  return header.column_type === descriptive;
};

const isAdderColumn = (header: CustomColumnHeader): boolean => {
  if (!header || header._destroy) return false;
  return header.column_type === getAdderColumnType();
};

interface CheckColumnsLimitParams {
  headers: CustomColumnHeader[];
  maxDescriptiveColumnCount: number;
}

export const checkColumnsLimit = ({
  headers,
  maxDescriptiveColumnCount,
}: CheckColumnsLimitParams): boolean => {
  // TLC: We're going to need to check for Global.lots.custom_column_headers.column_types.qualifying
  const descriptiveColumns = headers.filter(isDescriptiveColumn);

  // TLC: We're going to need to check for maxQualifyingColumnCount too.
  return descriptiveColumns.length >= maxDescriptiveColumnCount;
};

export const checkAdderColumnsLimit = (
  headers: CustomColumnHeader[],
  maxAdderColumnCount: number = DEFAULT_MAX_ADDER_COLUMN_COUNT,
): boolean => {
  const adderColumns = headers.filter(isAdderColumn);
  return adderColumns.length >= maxAdderColumnCount;
};
